module.exports = __webpack_public_path__ + "static/media/emptyconversations.399020a0.svg";